import * as axios from "axios";
import {
  tokenConfig,
  parentQuesConfig,
  childQuesConfig,
  npsSubmitConfig,
  questionMasterConfig,

} from "./config";




export const generateAuthToken = () => {
  return axios(tokenConfig)
    .then((response) => {
      return response;
    })
    .catch((reason) => {
      // Handle 400
      if (reason.response?.status === 500) {
        return reason.response;
      }
    });
};

export const getParentQuestions = async ({ selectedRating, surveyType, language, conceptCode }) => {
  return await axios(
    parentQuesConfig(
      surveyType,
      selectedRating,
      language,
      conceptCode
    )
  )
    .then((response) => {
      return response;
    })
    .catch((reason) => {
      // Handle 400
      return reason.response;
    });
};

export const getChildQuestions = async ({ selectedQuestionId, language }) => {
  return await axios(
    childQuesConfig(
      selectedQuestionId,
      language
    )
  )
    .then((response) => {
      return response;
    })
    .catch((reason) => {
      // Handle 400
      if (reason.response?.status === 500) {
        return reason.response;
      }
    });
};

export const getQuestionsMaster = async (storeCode, conceptCode, categoryCode) => {
  return await axios(
    questionMasterConfig(
      storeCode,
      conceptCode,
      categoryCode
    )
  )
    .then((response) => {
      return response;
    })
    .catch((reason) => {
      // Handle 400
      if (reason.response?.status === 500) {
        return reason.response;
      }
    });
};

export const submitNPS = async ({ npsFormData }) => {
  return await axios(npsSubmitConfig(npsFormData))
    .then((response) => {
      return response;
    })
    .catch((reason) => {
      // Handle 400
      if (reason.response?.status === 500) {
        return reason.response;
      }
    });
};
